import React, { useEffect, useMemo } from "react";
import "./LessonOptions.scss";

const LessonOptions = ({
    optionGroups = [],
    selections = {},
    onChange,
    onPriceChange,
}) => {
    // 활성화된 그룹과 값만 필터링하여 order 기준 정렬
    const activeGroups = useMemo(() => {
        return optionGroups
            .filter((g) => g.is_active)
            .sort((a, b) => a.order - b.order)
            .map((g) => ({
                ...g,
                values: g.values
                    .filter((v) => v.is_active)
                    .sort((a, b) => a.order - b.order),
            }));
    }, [optionGroups]);

    // selections 또는 activeGroups 변경 시 총 가격 델타 계산
    useEffect(() => {
        let total = 0;
        activeGroups.forEach((group) => {
            const selected = selections[group.id] || [];
            group.values.forEach((v) => {
                if (selected.includes(v.id)) {
                    total += Number(v.price_delta);
                }
            });
        });
        if (typeof onPriceChange === "function") {
            onPriceChange(total);
        }
    }, [selections, activeGroups, onPriceChange]);

    const handleSelect = (group, valueId) => {
        const current = selections[group.id] || [];
        let updated;

        if (group.allow_multiple) {
            // 다중 선택: 토글
            updated = current.includes(valueId)
                ? current.filter((id) => id !== valueId)
                : [...current, valueId];
        } else {
            // 단일 선택
            if (current.includes(valueId)) {
                // 필수 항목이 아닐 때만 선택 해제 가능
                updated = group.is_required ? current : [];
            } else {
                updated = [valueId];
            }
        }

        if (typeof onChange === "function") {
            onChange({ ...selections, [group.id]: updated });
        }
    };

    if (activeGroups.length === 0) return null;

    return (
        <div className="lesson-options-wrap">
            {activeGroups.map((group) => (
                <div className="option-group" key={group.id}>
                    <div className="option-group-label">
                        {group.name}
                        {group.is_required && (
                            <span className="required-badge">필수</span>
                        )}
                    </div>
                    <div className="option-values">
                        {group.values.map((value) => {
                            const isSelected = (
                                selections[group.id] || []
                            ).includes(value.id);
                            return (
                                <button
                                    key={value.id}
                                    type="button"
                                    className={`option-value-btn${isSelected ? " selected" : ""}`}
                                    onClick={() =>
                                        handleSelect(group, value.id)
                                    }
                                    aria-pressed={isSelected}
                                >
                                    <span className="value-name">
                                        {value.name}
                                    </span>
                                    {Number(value.price_delta) !== 0 && (
                                        <span className="price-delta">
                                            ({Number(value.price_delta) > 0 ? "+" : ""}
                                            {Number(
                                                value.price_delta
                                            ).toLocaleString()}
                                            원)
                                        </span>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                    {group.is_required &&
                        !(selections[group.id]?.length > 0) && (
                            <p className="option-warning">
                                필수 선택 항목입니다
                            </p>
                        )}
                </div>
            ))}
        </div>
    );
};

export default LessonOptions;
